// extracted by mini-css-extract-plugin
export default {"header-container":"styles_header-container__Si69X","title":"styles_title__x8vOZ"};